<script setup>
import { computed, onMounted, onUnmounted } from 'vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
  // 'create' = formulario Crear Pedido | 'send' = seccion Enviar Pedido
  // 'factura' = panel Factura Electronica (DIAN via Odoo, factura.html)
  mode: {
    type: String,
    default: 'create',
  },
});

const store = useStore();
const currentChat = useMapGetter('getSelectedChat');
const contactGetter = useMapGetter('contacts/getContact');
const contactId = computed(() => currentChat.value?.meta?.sender?.id);
const contact = computed(() => contactGetter.value(contactId.value));

const iframeSrc = computed(() => {
  const inboxId = currentChat.value?.inbox_id || '';
  const phone = contact.value?.phone_number || '';
  const name = contact.value?.name || '';
  const email = contact.value?.email || '';
  const conversationId = props.conversationId || currentChat.value?.id || '';
  const params = new URLSearchParams({
    inbox_id: inboxId,
    phone: phone,
    name: name,
    email: email,
    conversation_id: conversationId,
    mode: props.mode,
  });
  // Pass GCLID/UTM attribution data from CONVERSATION custom_attributes (not contact)
  // Attribution is stored per-conversation to avoid cross-store overwrites
  const wcAttr = currentChat.value?.custom_attributes?.wc_attribution;
  if (wcAttr && typeof wcAttr === 'object') {
    params.set('attribution', JSON.stringify(wcAttr));
  }
  const page = props.mode === 'factura' ? 'factura.html' : 'index.html';
  return '/wc-dashboard/' + page + '?_v=6&' + params.toString();
});

function onIframeMessage(e) {
  if (e.data && e.data.type === 'wc-order-created') {
    const convId = currentChat.value?.id;
    if (!convId) return;
    const current = store.getters['conversationLabels/getConversationLabels'](convId);
    if (!current.includes('agendando')) {
      store.dispatch('conversationLabels/update', {
        conversationId: convId,
        labels: [...current, 'agendando'],
      });
    }
  }
}

onMounted(() => {
  window.addEventListener('message', onIframeMessage);
});

onUnmounted(() => {
  window.removeEventListener('message', onIframeMessage);
});
</script>

<template>
  <div class="wc-dashboard-wrap">
    <iframe
      :src="iframeSrc"
      class="wc-dashboard-frame"
      :style="{ height: props.mode === 'send' ? '45vh' : props.mode === 'factura' ? '75vh' : '70vh' }"
    />
  </div>
</template>

<style scoped>
.wc-dashboard-wrap {
  width: 100%;
}
.wc-dashboard-frame {
  width: 100%;
  height: 70vh;
  border: 0;
}
</style>
